import { autoUpdate } from '@floating-ui/dom';
import { calculate, type FloatingOptions } from './createFloating';

const createPortalFloating = async (options: FloatingOptions) => {
  const $portal = document.getElementById('portal') ?? document.body;
  const { parentNode, nextSibling } = options.$floating;

  $portal.appendChild(options.$floating);

  options.onCalculate(await calculate(options));

  const cancel = autoUpdate(options.$reference, options.$floating, async () => {
    options.onCalculate(await calculate(options));
  });

  return () => {
    parentNode?.insertBefore(options.$floating, nextSibling);
    cancel();
  };
};

export default createPortalFloating;
